// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__P2ctY","cell":"ColumnAccessor_cell__1MaJx","firstCellAccent":"ColumnAccessor_firstCellAccent__1JiaS"};